import {
  RECEIVE_SMARTLINK_MODELS,
  REQUEST_SMARTLINK_MODELS,
} from '@sophocles/entities/SmartlinkModel/smartlinkModelActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_SMARTLINK_MODELS:
      return action.smartlinkUnits;
    default:
      return state;
  }
}

export function smartlinkModelReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_SMARTLINK_MODELS:
      return state.merge(getState(state, action));
    case REQUEST_SMARTLINK_MODELS:
    default:
      return state;
  }
}
